import { globalConstants, activityConstants } from "../../constants";
import { acceptedActivity } from "../actions";

//Destructuring global constants
const { SUCCESS } = globalConstants;

//Default state of admin reducer
const initialState = {
  data: [],
  allData: [],
  formData: {},
  invoiceData: {},
  invoiceBase64: "",
  invoices: [],
  acceptedActivity: []
};
//Manipulating the state of admin portal based on actions and returning the state
export const activityReducer = (state = initialState, action) => {
  switch (action.type) {
    case activityConstants.GET_ACTIVITY + SUCCESS:
      return { ...state, data: action.data };
    case activityConstants.GET_ACTIVITY_LIST + SUCCESS:
      return { ...state, allData: action.data };
    case activityConstants.GET_ACTIVITY_BY_ID + SUCCESS:
      return { ...state, formData: action.data };
    case activityConstants.GET_INVOICE_BY_ACTIVITY_ID + SUCCESS:
      return { ...state, invoiceData: action.data };
    case activityConstants.GENERATE_INVOICE_BY_ACTIVITY_ID + SUCCESS:
      return { ...state, invoiceBase64: action.data };
    case activityConstants.GET_ALL_INVOICES + SUCCESS:
      return { ...state, invoices: action.data };
    case activityConstants.GET_ACCEPTED_ACTIVITIES + SUCCESS:
      return { ...state, acceptedActivity: action.data };
    default:
      return state;
  }
};
